module.exports = __webpack_public_path__ + "img/print_footprint@2x.b9e3930.jpg";